export default "__VITE_ASSET__3NHfXFx9__"